import styled from 'styled-components'
import { orange } from '@/theme/colors'

export const FormContainer = styled.form`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
	padding: 0.5rem 0;
`

export const FormGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`

export const Label = styled.label`
	font-size: 0.875rem;
	font-weight: 500;
	color: #374151;
`

export const Input = styled.input`
	padding: 0.625rem 0.75rem;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	font-size: 0.875rem;
	color: #111827;
	transition: all 0.2s;

	&:focus {
		outline: none;
		border-color: #3b82f6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
	}

	&::placeholder {
		color: #9ca3af;
	}
`

export const Select = styled.select`
	padding: 0.75rem;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	font-size: 0.875rem;
	color: #111827;
	background-color: white;
	cursor: pointer;
	transition: all 0.2s;

	&:focus {
		outline: none;
		border-color: #3b82f6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
	}
`

export const TextArea = styled.textarea`
	padding: 0.625rem 0.75rem;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	font-size: 0.875rem;
	color: #111827;
	font-family: inherit;
	resize: vertical;
	min-height: 80px;
	transition: all 0.2s;

	&:focus {
		outline: none;
		border-color: #3b82f6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
	}

	&::placeholder {
		color: #9ca3af;
	}
`

export const LocationSecondaryText = styled.div`
	font-size: 0.75rem;
	color: #6b7280;
	margin-top: 0.5rem;
	padding-left: 0.25rem;
`

export const LinksContainer = styled.div`
	margin-bottom: 0.5rem;
`

export const LinkInputRow = styled.div`
	display: flex;
	gap: 0.5rem;
	margin-bottom: 0.5rem;
`

export const LinkInput = styled(Input)`
	flex: 1;
`

export const RemoveLinkButton = styled.button`
	background: #ef4444;
	color: white;
	border: none;
	border-radius: 6px;
	padding: 0.25rem 0.5rem;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
`

export const AddLinkButton = styled.button`
	background: white;
	color: #374151;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	padding: 0.5rem 1rem;
	cursor: pointer;
	font-size: 0.875rem;
	font-weight: 500;
`

export const ButtonGroup = styled.div`
	display: flex;
	gap: 0.75rem;
	justify-content: flex-end;
	margin-top: 0.25rem;
`

export const CancelButton = styled.button`
	padding: 0.625rem 1.25rem;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	background: white;
	color: #374151;
	font-size: 0.875rem;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s;

	&:hover {
		background: #f9fafb;
		border-color: #9ca3af;
	}
`

export const SubmitButton = styled.button`
	padding: 0.625rem 1.25rem;
	border: none;
	border-radius: 6px;
	background: ${orange};
	color: white;
	font-size: 0.875rem;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s;

	&:hover:not(:disabled) {
		opacity: 0.9;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`
